import * as charts from '@mantine/charts';
import '@mantine/charts/styles.css';
import { Wrapper } from './Graph.style';

export type GraphProps = {
  chartType: keyof typeof charts;
  data: Json;
  series?: Json[];
  dataKey?: string;
  extraProps?: Json;
};

export function Graph(props: GraphProps) {
  const { data, series, chartType, dataKey, extraProps } = props;

  const Cmp = charts[chartType] as any;
  if (!Cmp) return null;

  return (
    <Wrapper className='Graph-wrapper' data-testid='Graph-wrapper'>
      <Cmp h={300} data={data} dataKey={dataKey} withLegend series={series} {...extraProps} />
    </Wrapper>
  );
}

export default Graph;
